import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { useCommonApi } from '../../../api';
import { onSuccessCustomApiResponse } from '../../../api/utils';
import { useNotify } from '../../../hooks';
import { AddNewAccountRequest, UserEmailAccountResponse } from '../../types/accident';

export const useAccount = () => {
  const [accountResult, setAccountResult] = useState<UserEmailAccountResponse | boolean | undefined>(undefined);
  const [addNewAccountDialogOpen, setAddNewAccountDialogOpen] = useState(false);
  const { notifyOnSuccess } = useNotify();

  const { mutate: getAccount } = useMutation(useCommonApi().getEmailAccount());
  const { mutate: createAccount, isPending: isCreatingAccount } = useMutation(useCommonApi().createAccount());

  const handleGetAccountEmail = (email?: string) => {
    if (!email) return null;
    getAccount(
      { email },
      {
        onSuccess: onSuccessCustomApiResponse({
          executed: (_, data) => {
            setAccountResult(data);
          },
          failed: () => setAccountResult(false)
        })
      }
    );
  };

  const handleCreateAccount = (formData: AddNewAccountRequest) => {
    createAccount(formData, {
      onSuccess: onSuccessCustomApiResponse({
        executed: () => {
          setAddNewAccountDialogOpen(false);
          setAccountResult(undefined);
          notifyOnSuccess('Účet byl úspěšně vytvořen');
        }
      })
    });
  };

  return {
    handleGetAccountEmail,
    accountResult,
    addNewAccountDialogOpen,
    setAddNewAccountDialogOpen,
    createAccount,
    isCreatingAccount,
    handleCreateAccount
  };
};
